/* tslint:disable */
/* eslint-disable */
import { FrageDisplayModel as AceXFoundPortalCoreCaqModelsFrageDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/frage-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { FrageDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsFrageDisplayModelFormGroup } from '@/api/model-index';

export interface IFragenVonAbschnittDisplayModel {
  abschnittId?: string;
  fragen?: null | Array<AceXFoundPortalCoreCaqModelsFrageDisplayModel>;
  reportId?: null | string;
}
export class FragenVonAbschnittDisplayModel extends BaseModel implements IFragenVonAbschnittDisplayModel {
  abschnittId?: string;
  fragen?: null | Array<AceXFoundPortalCoreCaqModelsFrageDisplayModel>;
  reportId?: null | string;
}
class BaseFragenVonAbschnittDisplayModelFormGroup extends FormGroup {
  private static _instance: FragenVonAbschnittDisplayModelFormGroup;
  
  public static get Instance(): FragenVonAbschnittDisplayModelFormGroup {
    this._instance = new FragenVonAbschnittDisplayModelFormGroup({
      abschnittId: new FormControl(null),
      fragen: new FormArray([]),
      reportId: new FormControl(null),
    });

    return this._instance;
  }
}


export class FragenVonAbschnittDisplayModelFormGroup extends BaseFragenVonAbschnittDisplayModelFormGroup {
  public get AbschnittId(): FormControl {
    return this.controls["abschnittId"] as FormControl;
  }
  public get Fragen(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsFrageDisplayModelFormGroup> {
    return this.controls["fragen"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsFrageDisplayModelFormGroup>;
  }
  public get ReportId(): FormControl {
    return this.controls["reportId"] as FormControl;
  }
  

}

export module FragenVonAbschnittDisplayModelForm
  {
    export class FormFields
    {
      static _abschnittId: string = "abschnittId";
      static _fragen: string = "fragen";
      static _reportId: string = "reportId";
    }
  }

